<div class="modal-backdrop fade {{modalOptions?.backdropClass || ''}}" 
                  [ngStyle]="{'z-index': 1040 + instanceCount * 10 +1}" [ngClass]="{'in': isOpen}">
             </div>